/**
 * Example JavaScript singleton module
 */

var Scroll = (function($) {
  function initScroll() {
    const lenis = new Lenis();

    lenis.on("scroll", e => {
      //   console.log(e);
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
    // do something
  }

  function init() {
    // return early if no corresponding module present
    if (!$("body").length) {
      return;
    }

    initScroll();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Scroll.init);
